import React from "react"
import Heading from "@/components/core/Heading/Heading"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import PropTypes from "prop-types"

const PriceLabel = props => {
  const { t } = useTranslation("common")
  const { discontinuedText = "", outOfStockText } = getTranslations(t)
  const { priceInfo, itemStock } = props
  const {
    currentVarent: {
      currencySign = null,
      details = null,
      discountedPrice = null,
      value = null,
      price = "NaN",
    },
    Name: name,
  } = priceInfo
  return (
    <div className="inner-contents">
      {itemStock ? (
        <p className={`fs-13 fw-600 tag-discontinue mb-5 outof-stoke`}>
          {outOfStockText}
        </p>
      ) : null}
      {details?.discontinued === false ? null : (
        <p className="fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued">
          {discontinuedText}
        </p>
      )}
      <Heading level={2} className="label-name fs-28 fw-325 text-capitalize">
        {name?.toLowerCase() || "N/A"}
      </Heading>
      <div className="product-with-price">
        <p className="varient-text fs-14 fw-500">{value || "N/A"}</p>
        <div className="price-part d-flex">
          {price !== "NaN" ? (
            <>
              {discountedPrice ? (
                <Heading
                  level={2}
                  className="price-text fs-28 fw-325 text-capitalize "
                >
                  {currencySign}
                  {discountedPrice}
                </Heading>
              ) : null}
              <p
                className={`price-text fs-16 fw-400 text-capitalize ml-5 ${
                  discountedPrice ? "discount-price" : ""
                }`}
              >
                {currencySign}
                {price}
              </p>
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}

PriceLabel.propTypes = {
  priceInfo: PropTypes.shape({
    currentVarent: PropTypes.shape({
      currencySign: PropTypes.string.isRequired,
      details: PropTypes.string.isRequired,
      discountedPrice: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    }),
    Name: PropTypes.string.isRequired,
  }),
  itemStock: PropTypes.string.isRequired,
}

export default PriceLabel
